import React, { Component } from 'react';
import BsySwitchBtn from "../BsySwitchBtn";
import BsyIconBtn from "../BsyIconBtn";
import BsySearchInput from "../BsySearchInput";
import BsyTableList from "../BsyTableList";
import BsyMemberSyncLog from '../BsyMemberSyncLog'
import BsyAlertInviteUser from "../BsyAlertInviteUser";
import BsyAlert from "../BsyAlert";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertQYWorkConfig from "../BsyAlertQYWorkConfig";
import { $Bsy, BsyUtils } from "../../utils/Utils";
import BsyAlertListDetail from "../BsyAlertListDetail";
import BsyAlertHandover from "../BsyAlertHandover";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyDialog from '../BsyDialog';
import BsyApprovePane from '../BsyApprovePane';
import JobtitleList from './JobtitleList';
import BsyCreateRelationPane from "../BsyCreateRelationPane";
import BsyBubble from "../BsyBubble";
import BsyDesignSetIconPane from "../dashboard/BsyDesignSetIconPane";
import BsyRadioGroup from "../BsyRadioGroup";
import BsyButton from "../BsyButton";


class BsyUserCont extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userCont: {},
            selectDepts: props.selectDepts ? props.selectDepts : {},
            deptId: props.deptId,
            hasCount: true,
            hasChild: false, //是否显示子部门成员
            limit: this._getStoreValue('usercontlimit') || 20,
            skip: 0,
            filter: "",
            verifyBtn: true,
            approves: false,
            success: false,
            departments: props.departments,
            roles: props.roles,
            _id: null,
            jobtitles: [],
            jobtitlesMore: [],
            job_title: '',
            checkList: [],
            checkListDetail:[],
            filterText: React.language('all'),
            inviteStatus: 0,
            isloading: false,
        }
        this.emailCodeLogin = false;
        this.jobref = React.createRef();
        this.userContEl = React.createRef();
    }

    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.RefreshList()
        })
    }

    _getStoreKey = (name) => {
        return BsyUtils.Store.getKey(name, {
            userId: window.FX.STATIC.corpId,
        })
    }

    _getStoreValue = (name) => {
        let t = this._getStoreKey(name);
        return BsyUtils.Store.get(t)
    }

    listLimitChange = (e) => {
        // console.log('listLimitChange', e)
        this.setState({
            skip: 0,
            limit: e,
        }, () => {

            this._updateStoreValue('usercontlimit', e)
            this.RefreshList()
        })
    }

    _updateStoreValue = (name, val) => {
        let i = this._getStoreKey(name)
        BsyUtils.Store.set(i, val)
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.RefreshList()
        })
    }

    deptRefresh = (val, deptName) => {
        this.deptNode = {
            ...val
        }
        this.setState({
            job_title: '',
            deptId: val ? val.departmentId : null,
            _id: val ? val._id : null,
            limit: 20, skip: 0,
        }, () => {
            this.RefreshList()
        })
    }

    setDepartments = (departments) => {
        this.setState({ departments: departments })
    }

    setRoles = (roles) => {
        this.setState({ roles: roles })
    }

    componentDidMount() {
        this.RefreshList();
        this.get_approve_list();
    }

    onSearch = () => {
        const { deptId, hasCount, limit, skip, hasChild, job_title, inviteStatus } = this.state
        const filter = this.searchValue.getValue()
        React.axios('/corp/department/list_member', {
            deptId: deptId,
            filter: filter,
            hasCount: hasCount,
            hasChild: hasChild,
            searchType: 'all',
            limit: limit,
            skip: skip * limit,
            job_title: job_title,
            status: inviteStatus,
        }).then(res => {
            this.emailCodeLogin = res.data.emailCodeLogin
            this.setState({ userCont: res.data })
        }).catch(res => {

        })
    }

    RefreshList = () => {
        const { deptId, hasCount, limit, skip, filter, hasChild, _id, job_title, selectDepts, inviteStatus } = this.state
        this.setState({
            isloading: true
        },()=>{
            let mask = window.FX.Utils.createLoadLayer(window.$(this.userContEl.current), {
                hasLoader: !0
            })
            React.axios('/corp/department/list_member', {
                deptId: deptId,
                hasCount: hasCount,
                hasChild: hasChild,
                filter: filter,
                limit: limit,
                searchType: 'all',
                skip: skip * limit,
                job_title: job_title,
                status: inviteStatus
            }).then(res => {
                this.emailCodeLogin = res.data.emailCodeLogin
                let joburl = '/corp/department/job_title';
                if (!deptId) {
                    joburl = '/corp/department/all_job_title';
                }
                React.axios(joburl, {
                    deptId: deptId,
                    mode: hasChild ? "currentSub" : 'current',
                    _id: _id ? _id : selectDepts._id,
                }).then(res1 => {
                    let joblist = [];
                    if (deptId) {
                        joblist = res1.data.items;
                    } else {
                        joblist = res1.data.list.map((d) => {
                            return d.value;
                        })
                    }

                    this.setState({
                        userCont: res.data,
                        checkListDetail: [],
                        checkList: [],
                        isloading: false
                    }, () => {
                        this.setState({
                            ...this.getJobTitles(joblist),
                            job_title_list: res1.data.list || [],
                        })
                        this.props.getUserCont && this.props.getUserCont(this);
                        mask && mask.remove();
                    })
                }).catch(res => {
                    this.setState({
                        userCont: res.data,
                        checkListDetail: [],
                        checkList: [],
                        isloading: false,
                    },()=>{
                        this.setState({
                            jobtitles: [],
                            jobtitlesMore: [],
                        })
                        mask && mask.remove();
                    })
                })

            }).catch(res => {
                mask && mask.remove();
            })
        })

    }

    getJobTitles = (items) => {

        if (this.jobref.current) {
            let jobtitles = [];
            let jobtitlesMore = [];
            let jobManageWidth = BsyUtils.getSpanTextWidth(React.language('position.management'), "14px") + 62;
            let jobMoreWidth = BsyUtils.getSpanTextWidth(React.language('more'), "14px") + 50;
            let dd = this.jobref.current.offsetWidth - jobManageWidth - jobMoreWidth;
            let b = 0
            for (let i = 0; i < items.length; i++) {

                let d = BsyUtils.getSpanTextWidth(items[i], "14px") + 32;
                if (b + d > dd) {
                    jobtitlesMore.push(items[i])
                } else {
                    b += d;
                    jobtitles.push(items[i])
                }
            }

            return {
                jobtitles: jobtitles,
                jobtitlesMore: jobtitlesMore,
            }
        }

        return {
            jobtitles: [],
            jobtitlesMore: [],
        }
    }

    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    inviteUser = () => {
        const departTree = BsyUtils.transformToTreeFormat(this.props.departments);
        BsyAlertInviteUser({
            title: React.language('dashboard.guide.invite.action'),
            styleCss: {
                width: 760,
                height: 570
            },
            departmentId: !BsyUtils.isObjectEmpty(this.deptNode) ? [{ nickname: this.deptNode.name, _id: this.deptNode._id }] : (BsyUtils.isSubAdmin() ? [{ nickname: departTree[0].name, _id: departTree[0]._id }] : null),
            emailCodeLogin: this.emailCodeLogin,
            deptId: !BsyUtils.isObjectEmpty(this.deptNode) ? this.deptNode._id : null,
            isAllDept: BsyUtils.isObjectEmpty(this.deptNode),
            onRefresh: () => {
                this.RefreshList();
            },
        })
    }

    memberSync = () => {
        let n = window.FX.Utils.createLoadLayer(window.$(document.getElementsByTagName("body")[0]), {
            isLight: !0,
            hasLoader: !0
        });
        React.axios("/corp/user_sync").then(res => {
            n.remove()
            if (res.data == '') {
                tipAlert({
                    type: 'warning',
                    msg: '服务器通讯异常,请管理人员'
                })

                // tipAlert({
                //     type: "warning",
                //     msg: "服务器通讯异常,请管理人员"
                // })
            } else {
                if (res.data.code === 40000) {

                    if (this.props.onMemberSync) {
                        this.props.onMemberSync();
                    }
                    tipAlert({
                        type: "success",
                        msg: React.language("member.async.success")
                    })
                }
                else {
                    tipAlert({
                        type: "warning",
                        msg: React.language(res.data.msg)
                    })
                }
            }

        }).catch(res => {
            n.remove()
        })
    }


    memberSyncLog = () => {
        if (BsyUtils.isCommon()) {
            return;
        }
        BsyDialog({
            title: React.language('dingding.auto.syn.log'),
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyMemberSyncLog
                />
            }
        })
    }

    alertExport = () => {
        BsyAlert({
            title: React.language("prompt1"),
            msg: React.language("Export.tip", { name: React.language("allMember") }),
            type: "query",
            text4Ok: React.language("ok"),
            OkType: "blue",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios("/manager/team/" + window.FX.Utils.getCurrentCorp() + "/export", {
                    departmentId: null
                }).then(res => {
                    let h = res.data.data;
                    if (h.success > 0) {
                        window.location.href = h.info;
                    }
                    tipAlert({
                        type: h.success > 0 ? "success" : 'error',
                        msg: h.success > 0 ? React.language("Export.success") : h.info
                    })
                }).catch(res => {

                })
            }
        })
    }

    memberDept = () => {
        const { checkListDetail } = this.state;
        if (!checkListDetail || checkListDetail.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('move.tip')
            })
            return
        }
        this._createChangeDepartmentBubble(checkListDetail)
    }

    _createChangeDepartmentBubble = (b) => {
        if (!b || b.length <= 0)
            return void tipAlert({
                type: "warning",
                msg: React.language("move.tip")
            });
        let that = this;

        const members = b.map((item, index) => {
            //selectMap
            return item._id;
        })

        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    departmentEnable: !0,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    hasDock: !1,
                }]]
            },
            onOk: function () {
                let dept = d.getWidgetByName("memberSelect");
                let d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.departs.length === 0) {
                    return
                }
                const departments = d1.departs.map((item, index) => {
                    return dept.selectMap[item].departmentId
                })

                React.axios('/corp/change_department', {
                    members: members,
                    departments: departments,
                }).then(res => {
                    // BsyUtils.showAjaxTip(res.data, () => {
                    //     that.RefreshList();
                    // })
                    tipAlert({
                        msg: React.language("dept.move.tip"),
                        type: "success"
                    })
                    that.setState({
                        checkList: [],
                        checkListDetail:[]
                    },()=>{
                        that.RefreshList()
                        d.close()
                    })

                }).catch(res => {

                })

                return !1;
            }
        });
        d.show()
    }

    getTableValue = (rel) => {
        this.tableValue = rel;
    }


    jobtitleAdd = (cb) => {
        const _this = this;
        let f = new window.FX.ConfirmDialog({
            title: React.language("新增职位"),
            width: 340,
            height: 170,
            text4Ok: React.language("add"),
            contentWidget: {
                rowSize: [30],
                colSize: [300],
                padding: 20,
                items: [[{
                    type: "text",
                    widgetName: "groupName",
                    waterMark: "请填写职位",
                    allowBlank: !1
                }]]
            },
            onOk: function () {
                let g = this.getWidgetByName("groupName");
                let value = g.getValue();
                if (!value) {
                    tipAlert({
                        type: "warning",
                        msg: '职位不能为空'
                    })
                    return;
                }
                cb && cb(value)
                f.close()
            }
        });
        f.show()
    }



    setJobTitle = () => {
        const { deptId } = this.state;
        const { checkListDetail } = this.state;
        if (!checkListDetail || checkListDetail.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('jobtitle.set.tip')
            })
            return
        }
        this.selectJobtitle = null;
        React.axios('/corp/department/all_job_title', {
            mode: 'current',
        }).then(res1 => {
            BsyDialog({
                title: React.language("jobtitle.set"),
                height: 400,
                width: 450,
                okText: React.language("ok"),
                cancelText: React.language("cancel"),
                onContentCreate: () => {
                    return <JobtitleList
                      jobtitles={res1.data.list}
                      sortEnabled={true}
                      onStopEdit={(e) => {
                          this.selectJobtitle = e;
                      }}
                      onSortPost={(e) => {
                          this.onSortPost(e);
                      }}
                    >
                    </JobtitleList>
                },
                onOk: () => {

                    if (!this.selectJobtitle) {
                        tipAlert({
                            type: 'warning',
                            msg: React.language('position.select.tip')
                        })
                        return false
                    }
                    const members = checkListDetail.map((item, index) => {
                        //selectMap
                        return item._id;
                    })
                    React.axios('/corp/department/change_job_title', {
                        "members": members,
                        "department_id": deptId,
                        "job_title": this.selectJobtitle
                    }).then(res1 => {
                        this.RefreshList()

                    }).catch(res => {

                    })
                }
            })
        }).catch(res => {

        })


    }

    onSortPost = (items) => {
        let bd = items.map((data) => {
            return data.value;
        })
        React.axios('/corp/department/job_title_sort', {
            items: bd,
        }).then(res1 => {

        }).catch(res => {

        })
    }



    dismissionClick = () => {

        const { checkListDetail } = this.state;
        const _this = this;
        let members = [];
        let flag = false;
        if (!checkListDetail || checkListDetail.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('dismission.error.tip2')
            })
            return
        }
        checkListDetail.forEach((val, obj) => {
            if (val.category === 2) {
                members.push(val._id)
            } else {
                flag = true
            }
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('dismission.error.tip')
            })
            return
        }

        BsyAlert({
            type: "query",
            title: React.language("dismission.alert.tip"),
            msg: React.language("dismission.alert.tip1"),
            text4Ok: React.language("dismission"),
            ok: function () {
                const { checkListDetail } = _this.state;
                let members = [];
                let flag = false;
                checkListDetail.forEach((val, obj) => {
                    if (val.category === 2) {
                        members.push(val._id)
                    } else {
                        flag = true
                    }
                })
                React.axios('/corp/member/dismission', {
                    members
                }).then(res => {
                    if (flag) {
                        tipAlert({
                            type: 'warning',
                            msg: React.language('dismission.error.tip')
                        })
                    } else {
                        _this.RefreshList()
                    }
                }).catch(res => {

                })
            }
        });
    }

    enableClick = () => {

        const { checkListDetail } = this.state;
        const _this = this;
        let members = [];
        let users = [];
        let flag = false;
        checkListDetail.forEach((val, obj) => {
            if (val.category === 2) {
                if(val.frozen !== 0){
                    members.push(val._id)
                    users.push(val.nickname)
                }
            } else {
                flag = true
            }
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('enable.error.tip')
            })
            return
        }

        if (!members || members.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('enable.error.tip2')
            })
            return
        }

        BsyAlert({
            type: "query",
            title: React.language("enable.alert.tip"),
            msg: React.language("enable.alert.tip1",{length1: checkListDetail.length, length2: members.length}),
            text4Ok: React.language("enable"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/member/batch_recover', {
                    member_id_list: members
                }).then(res => {
                    tipAlert({
                        type: 'success',
                        msg: React.language('enable.success.tip', {length: res.data.data.success_num, users: users.join("、")})
                    })
                    _this.RefreshList()
                }).catch(res => {

                })
            }
        });
    }

    deactivateClick = () => {

        const { checkListDetail } = this.state;
        const _this = this;
        let members = [];
        let users = [];
        let flag = false;

        checkListDetail.forEach((val, obj) => {
            if (val.category === 2) {
                if(val.frozen === 0){
                    members.push(val._id)
                    users.push(val.nickname)
                }
            } else {
                flag = true
            }
        })

        if (flag) {
            tipAlert({
                type: 'warning',
                msg: React.language('deactivate.error.tip')
            })
            return
        }

        if (!members || members.length <= 0) {
            tipAlert({
                type: 'warning',
                msg: React.language('deactivate.error.tip2')
            })
            return
        }

        BsyAlert({
            type: "query",
            title: React.language("deactivate.alert.tip"),
            msg: React.language("deactivate.alert.tip1",{length1: checkListDetail.length, length2: members.length}),
            text4Ok: React.language("deactivate"),
            text4Cancel: React.language("cancel"),
            OkType: "red",
            ok: function () {
                React.axios('/corp/member/batch_freeze', {
                    member_id_list: members
                }).then(res => {
                    tipAlert({
                        type: 'success',
                        msg: React.language('deactivate.success.tip', {length: res.data.data.success_num, users: users.join("、")})
                    })
                    _this.RefreshList()
                }).catch(res => {

                })
            }
        });
    }

    switchChange = (val) => {
        if (window.FX.STATIC.user_corps.mode === "qyweixin") {
            if (val && this.state.userCont.qyweixin_callback_setting) {
                BsyAlertQYWorkConfig({
                    title: React.language('weChat.contacts.auth.title'),
                    styleCss: {
                        width: 966,
                        height: 500
                    }
                })
            }

            React.axios('/qyweixin/call_back_setting').then(res => {

            }).then(res => {

            }).catch(res => {

            })

            React.axios('/qyweixin/call_back_addressbook', {
                status: val
            }).then(res => {
                let userCotent = { ...this.state.userCont, ...{ qyweixin_callback_status: res.data.callback_status } };
                this.setState({
                    userCont: userCotent
                })
            }).catch(res => {

            })

        } else if (window.FX.STATIC.user_corps.mode === "dingding") {
            React.axios('/dingding/call_back_addressbook', {
                status: val
            }).then(res => {
                const { params } = res.data
                if(params && !BsyUtils.isObjectEmpty(params)){
                    BsyDialog({
                        title: React.language('config.info'),
                        height: 360,
                        width: 650,
                        noFooter: true,
                        onContentCreate: () => {
                            return <div className="dingdingCallBackInfo">
                                <div className="infoTitle">在 开发管理-{">"}事件订阅 中配置推送参数</div>
                                <div className="infoList">
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('push.method')}</div>
                                        <div className="infoItemValue">HTTP推送</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('encryption.aes_key')}</div>
                                        <div className="infoItemValue">{params.aes_key}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('signature.token')}</div>
                                        <div className="infoItemValue">{params.token}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('request.URL')}</div>
                                        <div className="infoItemValue">{params.url}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('event.subscription')}</div>
                                        <div className="infoItemValue">开启所有的通讯录事件</div>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                }
                let userCotent = { ...this.state.userCont, ...{ callback_status: res.data.callback_status } };
                this.setState({
                    userCont: userCotent
                })
            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "fugou") {
            React.axios('/fugou/call_back_addressbook', {
                status: val
            }).then(res => {
                let userCotent = { ...this.state.userCont, ...{ fugou_callback_status: res.data.callback_status } };
                this.setState({
                    userCont: userCotent
                })
            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "dingding") {
            React.axios('/dingding/call_back_addressbook', {
                status: val
            }).then(res => {
                const { params } = res.data
                if(params && !BsyUtils.isObjectEmpty(params)){
                    BsyDialog({
                        title: React.language('config.info'),
                        height: 360,
                        width: 650,
                        noFooter: true,
                        onContentCreate: () => {
                            return <div className="dingdingCallBackInfo">
                                <div className="infoTitle">在 开发管理-{">"}事件订阅 中配置推送参数</div>
                                <div className="infoList">
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('push.method')}</div>
                                        <div className="infoItemValue">HTTP推送</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('encryption.aes_key')}</div>
                                        <div className="infoItemValue">{params.aes_key}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('signature.token')}</div>
                                        <div className="infoItemValue">{params.token}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('request.URL')}</div>
                                        <div className="infoItemValue">{params.url}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('event.subscription')}</div>
                                        <div className="infoItemValue">开启所有的通讯录事件</div>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                }
                let userCotent = { ...this.state.userCont, ...{ callback_status: res.data.callback_status } };
                this.setState({
                    userCont: userCotent
                })
            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "feishu") {
            React.axios('/feishu/call_back_addressbook', {
                status: val
            }).then(res => {
                let userCotent = { ...this.state.userCont, ...{ feishu_callback_status: res.data.callback_status } };
                this.setState({
                    userCont: userCotent
                })
            }).catch(res => {

            })
        } else {
            React.axios('/corp/set_name_modify', {
                has_name_modify: val
            }).then(res => {

            }).catch(res => {

            })
        }
    }

    qywechatConfig = () => {
        BsyAlertQYWorkConfig({
            title: React.language('weChat.contacts.auth.title'),
            styleCss: {
                width: 966,
                height: 500
            }
        })
    }

    _createChangOutsiderBubble = (b) => {
        if (!b || b.length <= 0)
            return void tipAlert({
                type: "warning",
                msg: React.language("move.tip")
            });
        let that = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    // widgetName: "memberSelect",
                    // type: "memberselectpane",

                    // radioEnable:!0,
                    // checkEnable:!1,
                    // memberEnable: !1,
                    // departmentEnable: !1,
                    // outsiderMemberEnable:!1,
                    // // outsiderGroupEnable:!1,
                    // roleEnable:!1,
                    // dynamicEnable: !1,
                    // dynamicType: "set"

                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    radioEnable: !0,
                    checkEnable: !1,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    // outsiderGroupEnable:!1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                }]]
            },
            onOk: function () {
                let dept = d.getWidgetByName("memberSelect")
                let d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.outsiderGroup.length == 0) {
                    return
                }

                React.axios("/corp/member/transfer", {
                    user_id: b,
                    group_id: d1.outsiderGroup[0],
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        that.RefreshList();
                        d.close()
                    })

                }).catch(res => {

                })
                return !1;
            }
        });
        d.show()
    }

    memberRowClick = (event, item) => {
        const { departments, userCont, roles } = this.state;
        let depts = [];
        let mainDepts = [];
        let rls = [];
        let jobs = [];
        // console.log(item)
        departments.map((item1, index) => {
            if (item.deptids.indexOf(item1.departmentId) > -1) {
                depts.push({
                    nickname: item1.name,
                    id: item1.departmentId,
                    _id: item1._id,
                })
            }

            if (item.main_deptId === item1.departmentId) {
                mainDepts.push({
                    nickname: item1.name,
                    id: item1.departmentId,
                    _id: item1._id,
                })
            }

            if (item.job_title) {
                item.job_title.map(res=>{
                    if(res[item1.departmentId]){
                        jobs.push({
                            nickname: item1.name,
                            id: item1.departmentId,
                            _id: item1._id,
                            job: res[item1.departmentId]
                        })
                    }
                })
            }
        })

        roles.map((item1, index) => {
            if (item.role.indexOf(item1.role_id) > -1) {
                rls.push({
                    nickname: item1.name,
                    id: item1.role_id,
                    _id: item1._id,
                })
            }
        })

        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {

            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    //     this.removeAlert()

                    // departments


                    BsyAlertListDetail({
                        ...item,
                        ...{ departments: depts, jobs: jobs, roles: rls },
                        roleSync: userCont.role_sync,
                        relation_list: userCont.relation_list,
                        relation_status: userCont.relation_status,
                        memberRemove: userCont.memberRemove,
                        emailCodeLogin: userCont.emailCodeLogin,
                        mobileCodeLogin: userCont.mobileCodeLogin,
                        onReList: () => {
                            this.RefreshList()
                        }
                    })
                    document.getElementsByTagName('body')[0].style.overflow = "hidden"
                }
            }];
            if (item.category !== -1) {
                menu.push({
                    text: React.language('handover.work'),
                    colorType: "",
                    click: () => {
                        // this.removeAlert()
                        // BsySliderHandover({
                        //     userInfo:item,
                        //     title:React.language('handover.work')
                        // })
                        BsyAlertHandover({
                            userInfo: item,
                            title: React.language('handover.work'),
                            styleCss: {
                                width: "966px",
                                height: "582px",
                                maxHeight: "calc(100% - 100px)"
                            },
                            onClose: () => {
                                this.RefreshList()
                            }
                        })
                    }
                })
            }
            if (item.category === -1 && userCont.memberRemove) {
                menu.push({
                    text: React.language('delete'),
                    colorType: "red",
                    click: () => {
                        const { _id } = item;
                        //     this.removeAlert()
                        BsyAlert({
                            title: React.language("del.tip1"),
                            msg: '',
                            type: "warning",
                            text4Ok: React.language("delete"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                React.axios("/manager/team/" + window.FX.Utils.getCurrentCorp() + "/delete", {
                                    members: [_id], // 成员ID
                                    department_id: 1 //部门ID，1表示全部成员下
                                }).then(res => {
                                    tipAlert({
                                        type: "success",
                                        msg: React.language("member.delete.success")
                                    })
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                })
            } else if (item.category === 2) {
                menu.push({
                    text: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                    colorType: "",
                    click: () => {
                        const { _id } = item;
                        BsyAlert({
                            title: React.language(item.frozen === 0 ? "deactivate.alert.tip" : "enable.alert.tip"),
                            msg: React.language((item.frozen === 0 ? "deactivate.alert.tip1" : "enable.alert.tip1"),{length1: 1, length2: 1}),
                            type: "query",
                            text4Ok: React.language(item.frozen === 0 ? 'deactivate' : 'enable'),
                            OkType: item.frozen === 0 ? "red" : "blue",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                //     this.removeAlert()
                                React.axios(item.frozen === 1 ? '/corp/member/batch_recover' : '/corp/member/batch_freeze', {
                                    member_id_list: [_id]
                                }).then(res => {
                                    tipAlert({
                                        type: 'success',
                                        msg: React.language(item.frozen === 0 ? 'deactivate.success.tip' : 'enable.success.tip', {length: res.data.data.success_num, users: item.nickname})
                                    })
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                })
                if (BsyUtils.isCommon() && userCont.memberRemove) {
                    window.FX.STATIC.user_corps.mode === "common" && menu.push({
                        text: React.language('switch.to.resignation'),
                        colorType: "red",
                        click: () => {
                            const { _id } = item;
                            BsyAlert({
                                title: React.language("dismission.alert.tip"),
                                msg: React.language("dismission.alert.tip1"),
                                type: "query",
                                text4Ok: React.language("dismission"),
                                OkType: "red",
                                text4Cancel: React.language("cancel"),
                                ok: () => {
                                    //     this.removeAlert()
                                    React.axios('/corp/member/dismission', {
                                        members: [_id]
                                    }).then(res => {
                                        this.RefreshList()
                                    }).catch(res => {

                                    })
                                }
                            })
                        }
                    })
                    menu.push({
                        text: React.language('outsider.member.from.dept'),
                        colorType: "",
                        click: () => {
                            this._createChangOutsiderBubble(item._id);
                        }
                    })
                }
            }
            let tag = BsyUtils.closestClass(event.target, 'menuTd')
            BsyAlertMenu({
                item: menu,
                width: 140,
                target: event.target
            })
        } else if (event.target.classList[1] === "again") {
            // const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            if(item.category === -1){
                this.againAllInvite(item._id)
            }
        } else {
            BsyAlertListDetail({
                ...{
                    departments: depts, job_title: item.job_title, jobs: jobs, roles: rls,
                    roleSync: userCont.role_sync,
                    memberRemove: userCont.memberRemove,
                    relation_list: userCont.relation_list,
                    relation_status: userCont.relation_status,
                },
                ...item, onReList: () => {
                    this.RefreshList()
                }
            })
            document.getElementsByTagName('body')[0].style.overflow = "hidden"
        }


    }

    againAllInvite = (mobile) => {
        if(!BsyUtils.isCommon()) {
            return
        }
        BsyAlert({
            title: React.language("join.all.tip"),
            msg: "",
            type: "query",
            text4Ok: React.language("ok"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/member/reinvite', {
                    memberIds: BsyUtils.isObjectEmpty(mobile) ? [] : [mobile]
                }).then(res => {
                    tipAlert({
                        type: "success",
                        msg: React.language("Invited.tip3")
                    })
                }).catch(res => {
                    tipAlert({
                        type: "error",
                        msg: React.language("member.invite.error.tip")
                    })
                })
            }
        })
    }

    handleUserOrder = (data) => {
        React.axios('/corp/member/sort', data).then(res => {
            this.RefreshList()
        }).catch(res => {

        })
    }

    get_approve_list = () => {
        const { limit, deptId } = this.state

        // selectGroup 为空的时候 查询所有数据 不传分组id给后端
        React.axios('/corp/apply_check_list', {
            mode: "member",
            limit: limit,
            _id: deptId,
            status: 0, //查询未审核的人
            skip: 0
        }).then(res => {

            this.setState({
                approves: res.data.count > 0 ? true : false,
                success: true
            })

        }).catch(res => {

        })
    }

    approve_list = (val) => {


        BsyDialog({
            title: React.language('member') + React.language('member.invite.link.Audit'),
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyApprovePane
                  group_id={''} mode={'member'} status={3} />

            }
        })

    }

    showChildDept = () => {
        let hasChild = !this.state.hasChild;
        this.setState({
            hasChild: hasChild
        }, () => {
            this.RefreshList();
        })
    }

    deptMemager = () => {
        const { deptId } = this.state
        let that = this;
        let o = new window.FX.ConfirmDialog({
            title: React.language("dept.manager.set"),
            height: 590,
            width: 600,
            onOk: function () {
                let e = o.getWidgetByName("select_dept_manager");
                React.axios("/data/dept_set_manager", {
                    users: e.getValue(),
                    corpid: window.FX.STATIC.corpId,
                    department: deptId
                }).then(res => {
                    that.RefreshList();
                    o.close()
                }).catch(res => {

                })
                return !1
            },
            contentWidget: {
                rowSize: [450],
                colSize: [570],
                padding: 15,
                items: [[{
                    widgetName: "select_dept_manager",
                    type: "deptuser",
                    teamid: window.FX.STATIC.corpId,
                    department: deptId
                }]]
            }
        });
        o.show();

    }

    openSetQywechat = () => {
        const _this = this;
        let { userCont } = this.state
        new window.FX.WeChatContactsAuthDialog({
            agent_id: null,
            agent_secret: null,
            onStopEdit: function (agent) {
                userCont.qywx_bind_tip = false;
                _this.setState({
                    userCont
                })
            },
            onOk: function () {
                this._handleOk();
            }
        }).show();
    }

    showJobtitles = (data) => {
        const { job_title } = this.state;
        this.setState({
            job_title: job_title === data ? null : data,
            skip: 0,
        }, () => {
            this.RefreshList()
        })
    }

    deepCopy = (obj, visited = new WeakMap()) => {
        // 如果 obj 是 null 或不是对象，直接返回它自身
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        // 如果 obj 已经被访问过，返回它的副本以避免循环引用
        if (visited.has(obj)) {
            return visited.get(obj);
        }

        // 根据 obj 的类型创建一个新的空对象或数组
        let copy;
        if (Array.isArray(obj)) {
            copy = [];
        } else {
            copy = Object.create(Object.getPrototypeOf(obj));
        }

        // 记录访问过的 obj，以便处理循环引用
        visited.set(obj, copy);

        // 遍历 obj 的属性或数组元素并进行递归深拷贝
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                copy[key] = this.deepCopy(obj[key], visited);
            }
        }

        return copy;
    }

    showJobtitlesManage = () => {
        const { jobtitles, jobtitlesMore, job_title_list, job_title } = this.state;
        const relationMap = {};
        const relation_list = job_title_list.map((res)=>{
            const id = BsyUtils._genFormEventId();
            relationMap[id] = {
                name: res.value,
                _id: id,
                exist: res.exist
            };
            return relationMap[id]
        })
        BsyDialog({
            title: React.language('position.management'),
            height: 513,
            width: 520,
            noFooter: true,
            onContentCreate: (ref) => {
                return <BsyCreateRelationPane
                  createText={React.language('address.book.dept.jobtitle.add')}
                  listName={React.language('position.name')}
                  isJobTitle={!0}
                  jobtitles={this.deepCopy(jobtitles.concat(jobtitlesMore))}
                  relation_list={this.deepCopy(relation_list)}
                  relationMap={this.deepCopy(relationMap)}
                  dialogRef={ref}
                  onSave={(relation_list, relationMap, editedList, deledItems)=>{
                      const update = [];
                      const delItemList = deledItems.map(res =>{
                          return res.name
                      })
                      const joblist = relation_list.map(res =>{
                          return res.name
                      })
                      BsyUtils.forEach(editedList, (key, res)=>{
                          update.push(res)
                      })
                      React.axios("/corp/department/update_job_title", {
                          items: joblist,
                          update: update
                      }).then(res=>{
                          if(delItemList.indexOf(job_title) > -1){
                              if(joblist.length > 0){
                                  this.setState({...this.getJobTitles(joblist), job_title: joblist[0]},()=>{
                                      this.RefreshList()
                                  });
                              }else{
                                  this.setState({...this.getJobTitles(joblist), job_title: ''},()=>{
                                      this.RefreshList()
                                  });
                              }
                          }else{
                              this.setState({...this.getJobTitles(joblist)},()=>{
                                  this.RefreshList()
                              });
                          }

                      })
                  }}
                  // nodeSort={(attr) => {
                  //     const joblist = attr.map(res =>{
                  //       return res.name
                  //     })
                  //     this.setState({...this.getJobTitles(joblist)});
                  // }}
                />
            }
        })
    }

    showJobtitlesMore = (event) => {
        const { jobtitlesMore } = this.state;
        let menu = [];
        let width = 0;
        for (let index = 0; index < jobtitlesMore.length; index++) {
            const element = jobtitlesMore[index];
            const w = BsyUtils.getSpanTextWidth(element, "14px");
            if (w > width) {
                width = w;
            }
            menu.push({
                text: element,
                colorType: "",
                click: () => {
                    this.showJobtitles(element);
                }
            })
        }
        const t = event.currentTarget;
        t.classList.add('open');
        BsyAlertMenu({
            item: menu,
            width: width + 60,
            target: event.currentTarget,
            position: "bottom",
            onClose: ()=>{
                t.classList.remove('open');
                return !0
            }
        })
    }

    againAllValidate = () => {
        BsyAlert({
            title: React.language("verify.all.tip"),
            msg: "",
            type: "query",
            text4Ok: React.language("ok"),
            text4Cancel: React.language("cancel"),
            OkType: "blue",
            ok: function () {
                React.axios('/corp/member/validate', {
                    // mobile: !mobile ? "all" : mobile
                    mode: "all",
                    memberIds: []
                }).then(res => {
                    tipAlert({
                        type: "success",
                        msg: React.language("Invited.tip3")
                    })
                }).catch(res => {
                    tipAlert({
                        type: "error",
                        msg: React.language("member.invite.error.tip")
                    })


                    // window.FX.Vip.showUpgradeTip(res.data.responseJSON)
                })
            }
        })
    }

    verifyEmailMobile = (type, id, event) => {
        event.stopPropagation();
        const { verifyBtn } = this.state;
        if (verifyBtn) {
            this.setState({ verifyBtn: false }, function () {
                React.axios('/corp/member/validate', {
                    mode: type,
                    memberIds: [id]
                }).then(res => {
                    this.setState({ verifyBtn: true })
                    tipAlert({
                        type: res.data.success == 1 ? "success" : "error",
                        msg: res.data.info
                    })

                }).catch(res => {
                    this.setState({ verifyBtn: true })
                })
            })

        }
    }

    onCheck = (e) =>{
        this.setState({checkList: e.checkList, checkListDetail: e.checkListDetail, checked: e.checked})
    }

    onBsyTurnPageMid = () => {
        const { userCont } = this.state;
        const hasUserTip = userCont.qywx_bind_tip && userCont.hasOwnProperty("has_name_modify") && window.FX.STATIC.user_corps.mode === "qyweixin" && window.FX.STATIC.user_corps.isCorpOwn;
        return <>
            {
              hasUserTip && <div className="userTip">
                    <span>
                        {React.language('weChat.contacts.auth.tip')}
                    </span>
                  <button onClick={this.openSetQywechat}>
                      {React.language('vip.pack.order.ok')}
                  </button>
              </div>
            }
            {(userCont.not_joined > 0 || userCont.not_validate > 0) && <div className="tip-list">

                {
                  userCont.not_joined > 0 && <div className="joined-tip tip-item" onClick={e => { this.againAllInvite() }}  >
                      {/* <i className={'icon-bsy-laba'} /> */}
                      <div dangerouslySetInnerHTML={{ __html: React.language('addressbook.joined.tip', { num: userCont.not_joined }) }} />
                  </div>
                }
                {
                  userCont.not_validate > 0 && <div className="validate-tip tip-item" onClick={e => { this.againAllValidate() }}  >
                      {/* <i className={'icon-bsy-laba'} /> */}
                      <div dangerouslySetInnerHTML={{ __html: React.language('member.not.verify.tip1', { num: userCont.not_validate }) }} />
                  </div>
                }
            </div>}
        </>
    }


    renderInviteUserBtn = () => {
        // BsyUtils.isSubAdmin()
        const { userCont } = this.state;

        if (BsyUtils.isCommon()) {
            //子管理员
            if (userCont.memberInvite) {
                return <BsyIconBtn
                  text={React.language('dashboard.guide.invite.action')}
                  iconName="icon-bsy-iconquanbuchengyuan"
                  type="blue"
                  click={this.inviteUser}
                  mode={window.mode}
                />
            }

        }


        return ''

    }

    onSortItem = (e) => {
        let items = e;

        React.axios('/corp/department/member_list_map', {
            items
        }).then(() => {
            let userCotent = { ...this.state.userCont, ...{ member_list_map: items } };
            this.setState({
                userCont: userCotent
            })
        })
    }

    filterPane = (event, type) => {
        let bts = [
            { icon: '', text: React.language('all'), click: () =>{
                    this.setState({filterText: React.language('all'), inviteStatus: 0, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
            { icon: '', text: React.language('member.inviting'), click: () =>{
                    this.setState({filterText: React.language('member.inviting'), inviteStatus: 1, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
            { icon: '', text: React.language('activated'), click: () =>{
                    this.setState({filterText: React.language('activated'), inviteStatus: 2, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
            { icon: '', text: React.language('deactivated'), click: () =>{
                    this.setState({filterText: React.language('deactivated'), inviteStatus: 3, isFilter: true},()=>{
                        this.RefreshList()
                    })
                }},
        ]
        const t = event.currentTarget;
        t.classList.add('open');
        BsyAlertMenu({
            item: bts,
            width: 120,
            target: t,
            customCls: ' data-manage-batch-menu ',
            onClose: ()=>{
                t.classList.remove('open');
                return !0
            }
        })
    }

    closeCheckMenu = () =>{
        this.setState({checkList: [], checkListDetail: [], checked: false})
    }

    frozenVal = true;

    openSwitchFrozen = (event) => {
        const {userCont} = this.state;
        this.frozenVal = userCont.frozen_status
        BsyBubble({
            width: 240,
            height: 440,
            target: event,
            position: "right",
            getContext: (e) =>{
                this.bubbleContext = e;
            },
            onContentCreate: () => {
                return <div className="switchFrozenCont">
                    <div className="frozen-tip">{React.language("frozen.switch.tip")}</div>
                    <BsyRadioGroup
                      layout={'horizontal'}
                      value={this.state.userCont.frozen_status}
                      required={true}
                      items={[{
                          value: true,
                          text: React.language('enable'),
                      }, {
                          value: false,
                          text: React.language('deactivate'),
                      }]}
                      onStopEdit={(e, s, t) => {
                          this.frozenVal = e;
                      }}
                    ></BsyRadioGroup>
                    <div className="frozen-footer">
                        <BsyButton
                          text={React.language("cancel")}
                          type={'white '}
                          height={30}
                          click={() => {
                              this.bubbleContext.onRemoveRoot();
                          }}
                          mode={window.mode}
                        />
                        <BsyButton
                          text={React.language("ok")}
                          type={'blue'}
                          height={30}
                          click={() => {
                              React.axios("/corp/frozen_status",{
                                  status: this.frozenVal,
                                  team_mode: window.FX.STATIC.user_corps.mode
                              }).then(res => {
                                  userCont.frozen_status = this.frozenVal;
                                  this.setState({
                                      userCont
                                  })
                              })
                              this.bubbleContext.onRemoveRoot();
                          }}
                          mode={window.mode}
                        />
                    </div>
                </div>;
            },
            onClose: ()=>{

            }
        })
    }

    render() {
        const { isloading, filterText, userCont, limit, skip, approves, deptName, deptId, hasChild, success, departments, jobtitles, jobtitlesMore, job_title, roles, verifyBtn, checkList, checkListDetail, checked } = this.state;
        const editName = window.FX.STATIC.user_corps.mode !== "gzt" && window.FX.STATIC.user_corps.mode !== "fugou" && window.FX.STATIC.user_corps.mode !== "qyweixin" && window.FX.STATIC.user_corps.mode !== "dingding" && window.FX.STATIC.user_corps.mode !== "feishu";
        const sync = window.FX.STATIC.user_corps.mode === "gzt" || window.FX.STATIC.user_corps.mode === "fugou" || window.FX.STATIC.user_corps.mode === "qyweixin" || window.FX.STATIC.user_corps.mode === "dingding" || window.FX.STATIC.user_corps.mode === "feishu";
        let listUser = {
            nickname: {
                width: 280,
                key: "nickname",
                value: React.language("name")
            },
            uniqueid: {
                width: 280,
                key: "uniqueid",
                value: React.language("enterprise.user.id"),
                tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
            },
            phone: {
                width: 250,
                key: "phone",
                value: React.language("phone"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.phone} className="text">{value.phone}</span>
                        {value.phone && value.mobilestatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e => { this.verifyEmailMobile('mobile', value._id, e) }}>
                            {
                                React.language('verify')
                            }
                        </span>}
                    </>

                },
            },
            email: {
                width: 295,
                key: "email",
                value: React.language("email"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.email} className="text">{value.email}</span>
                        {value.email && value.emailstatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e => { this.verifyEmailMobile('email', value._id, e) }}>
                            {
                                React.language('verify')
                            }
                        </span>}
                    </>
                },
                tooltip: React.language("member.email.verify.tip")
            },
            job_title: {
                width: 208,
                title: true,
                key: "job_title",
                value: React.language("Title"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = [];
                    val.map(val1=>{
                        departments.map((item1, index) => {
                            if (item1.departmentId === deptId && val1[item1.departmentId]) {
                                curName.push(val1[item1.departmentId])
                            } else {
                                if (val1[item1.departmentId]) {

                                    jobs.push(`${item1.name} - ${val1[item1.departmentId]}`)
                                }
                            }
                        })
                    })

                    if (curName.length > 0)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            join_time: {
                width: 158,
                title: true,
                key: "join_time",
                value: React.language("join.time")
            },
            _id: {
                width: 158,
                title: true,
                key: "_id",
                value: 'userId'
            },
            remark: {
                width: 208,
                title: true,
                key: "remark",
                value: React.language("contact.note")
            },
            deptids: {
                width: 208,
                title: true,
                key: "deptids",
                value: React.language("department"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = '';
                    departments.map((item1, index) => {
                        if (val.indexOf(item1.departmentId) > -1) {
                            jobs.push(`${item1.name}`)
                        }
                    })
                    if (curName)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            role: {
                width: 208,
                title: true,
                key: "role",
                value: React.language("role"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = '';
                    roles.map((item1, index) => {
                        if (val.indexOf(item1.role_id) > -1) {
                            jobs.push(`${item1.name}`)
                        }

                    })
                    if (curName)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            sort: {
                width: 80,
                title: true,
                key: "sort",
                value: React.language("trigger.log.failure.index")
            },
        };

        let listAll = [
            {
                width: 280,
                key: "nickname",
                value: React.language("name")
            },
            {
                width: 280,
                key: "uniqueid",
                value: React.language("enterprise.user.id"),
                tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
            },
            {
                width: 250,
                key: "phone",
                value: React.language("phone")
            },
            {
                width: 295,
                key: "email",
                value: React.language("email"),
                onCellCreate: (items, value) => {
                    return <>
                        <span title={value.email} className="text">{value.email}</span>
                        {value.email && value.emailstatus == 0 && <span className={"verify " + (verifyBtn ? '' : 'not')} onClick={e => { this.verifyEmailMobile('email', value._id, e) }}>
                            {
                                React.language('verify')
                            }
                        </span>}
                    </>
                },
                tooltip: React.language("member.email.verify.tip")
            },
            {
                width: 208,
                title: true,
                key: "job_title",
                value: React.language("Title"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = '';
                    departments.map((item1, index) => {
                        if (item1.departmentId === deptId && val[item1.departmentId]) {
                            curName = val[item1.departmentId]
                        } else {
                            if (val[item1.departmentId]) {

                                jobs.push(`${item1.name} - ${val[item1.departmentId]}`)
                            }
                        }

                    })
                    if (curName)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            {
                width: 158,
                title: true,
                key: "join_time",
                value: React.language("join.time")
            },
            {
                width: 158,
                title: true,
                key: "_id",
                value: 'userId'
            },
            {
                width: 208,
                title: true,
                key: "remark",
                value: React.language("contact.note")
            },
            {
                width: 208,
                title: true,
                key: "deptids",
                value: React.language("department"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = '';
                    departments.map((item1, index) => {
                        if (val.indexOf(item1.departmentId) > -1) {
                            jobs.push(`${item1.name}`)
                        }
                    })
                    if (curName)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            {
                width: 208,
                title: true,
                key: "role",
                value: React.language("role"),
                onGetText: (val) => {

                    if (!val) {
                        return '';
                    }
                    if (BsyUtils.isString(val)) {
                        return val;
                    }
                    let jobs = [];
                    let curName = '';
                    roles.map((item1, index) => {
                        if (val.indexOf(item1.role_id) > -1) {
                            jobs.push(`${item1.name}`)
                        }
                    })
                    if (curName)
                        jobs = [curName, ...jobs];
                    return jobs.join('、')
                }
            },
            {
                width: 80,
                title: true,
                key: "sort",
                value: React.language("trigger.log.failure.index")
            }
        ];



        let list = [];

        if (userCont.member_list_map) {
            list = userCont.member_list_map.map((val) => {
                return listUser[val]
            })

            list.push({
                width: 90,
                key: "again",
                cls: "again",
                value: ""
            })
        }

        if (!this.deptNode) {
            this.deptNode = this.state.selectDepts;
        }

        return (
          <div className="user" ref={this.userContEl}>
              {!isloading && <div className="user-content">
                  <div className="userTitle">
                      <div className="leftUserCont">
                          <div className="title">
                              {this.deptNode ? this.deptNode.name ? this.deptNode.name : React.language('allMember') : React.language('allMember')}
                          </div>
                          {
                              deptId ? <div className="dept-menu" >
                                  {/* <div className="deptBtn" onClick={this.deptMemager}>
                                    <i className="icon-bsy-iconshezhi1" />
                                    {React.language('dept.manager.set')}
                                </div> */}
                                  {
                                      this.deptNode.children ?
                                        <div className="deptBtn" onClick={this.showChildDept}>
                                            {hasChild ? <i className="icon-bsy-filter-hide" /> : <i className="icon-bsy-filter-show" />}
                                            {hasChild ? React.language('none.dept') : React.language('dept.show.user')}
                                        </div> : ''
                                  }
                              </div> : <>
                                  {
                                      (sync && (BsyUtils.isSysManager() || BsyUtils.isCorpOwn())) ?
                                        <div className="switchCont">
                                            <i className={userCont.frozen_status ? "icon-bsy-user-enable" : "icon-bsy-user-deactivate"} onClick={this.openSwitchFrozen}></i>
                                            <span className="switchName">{React.language('dingding.auto.syn.switch')}</span>
                                            <BsySwitchBtn switchChange={this.switchChange} power={
                                                window.FX.STATIC.user_corps.mode === 'qyweixin' ? userCont.qyweixin_callback_status :
                                                  window.FX.STATIC.user_corps.mode === 'feishu' ? userCont.feishu_callback_status :
                                                    window.FX.STATIC.user_corps.mode === 'fugou' ? userCont.fugou_callback_status :
                                                    window.FX.STATIC.user_corps.mode === 'gzt' ? userCont.gzt_callback_status :
                                                      userCont.callback_status

                                            }/>
                                            {window.FX.STATIC.user_corps.mode === "qyweixin" && userCont.qyweixin_callback_setting &&
                                              <div className="qywechatConfig" onClick={this.qywechatConfig}>
                                                  {React.language('qyweixin.set.manage')}
                                              </div>}
                                        </div> :
                                        BsyUtils.isSubAdmin() ? '' : editName ? <div className="switchCont">
                                            <span className="switchName">{React.language('member.allow.edit.name')}</span>
                                            <BsySwitchBtn switchChange={this.switchChange} power={userCont.has_name_modify} />
                                        </div> : ''

                                  }
                              </>
                          }

                      </div>
                      <div className="jobtitle-list" ref={this.jobref} >
                          {
                            (deptId === null || deptId === undefined) && <div className={"jobtitle-item jobtitle-manage"} onClick={e => {
                                this.showJobtitlesManage()
                            }}>
                                <i className="icon-bsy-vipXTGLY"></i>
                                <span>{React.language('position.management')}</span>
                            </div>
                          }
                          {
                              jobtitles.map((data, index) => {
                                  if (index === 0) {
                                      return <>
                                          <div className={"jobtitle-item " + (job_title === data ? "select" : '')} onClick={e => { this.showJobtitles(data) }} >
                                              <span >{data}</span>
                                          </div>
                                      </>
                                  }


                                  return <>
                                      <span className="jobtitle-split">|</span>
                                      <div className={"jobtitle-item " + (job_title === data ? "select" : '')} onClick={e => { this.showJobtitles(data) }} >
                                          <span>{data}</span>
                                      </div></>
                              })
                          }
                          {
                              jobtitlesMore.length > 0 ? <div className="jobtitle-more" onClick={this.showJobtitlesMore}>
                                  {React.language('more')}
                                  <i className="icon-bsy-xia"></i>
                              </div> : ""
                          }
                      </div>
                  </div>
                  {checkList.length <= 0 ? <div className="userFunBtn">
                      <div className="btnCont">
                          {
                              this.renderInviteUserBtn()
                          }

                          {
                              (!BsyUtils.isCommon() && (BsyUtils.isSysManager() || BsyUtils.isCorpOwn() || window.FX.STATIC.user_corps.syncUser)) ? <BsyIconBtn
                                text={React.language('member.async.manual')}
                                iconName="icon-tongbu"
                                type="white"
                                hoverType="borderBlue"
                                click={this.memberSync}
                                mode={window.mode}
                              /> : ''
                          }

                          <BsyIconBtn
                            text={React.language('bulk.export')}
                            iconName="icon-vip-center-excel-import"
                            type="white"
                            hoverType="borderBlue"
                            click={this.alertExport}
                            mode={window.mode}
                          />

                          {
                              !BsyUtils.isCommon() ? <BsyIconBtn
                                text={React.language('dingding.auto.syn.log')}
                                iconName="icon-bsy-iconcaozuorizhi"
                                type="white"
                                hoverType="borderBlue"
                                click={this.memberSyncLog}
                                mode={window.mode}
                              /> : ''
                          }



                          {
                              BsyUtils.isSubAdmin() ? '' : !BsyUtils.isCommon() ? '' : approves ? <BsyIconBtn
                                text={React.language('member.invite.link.Audit.list')}
                                type="white"
                                hoverType="borderBlue"
                                iconName="icon-bsy-audit-list"
                                click={this.approve_list}
                                mode={window.mode}
                              /> : ''
                          }


                      </div>
                      <div className="searchCont">
                          <div className="filter-btn" onClick={this.filterPane}>
                              <span>{filterText}</span>
                              <i className="icon-bsy-xia"></i>
                          </div>
                          <BsySearchInput
                            placeholder={React.language('member.search1')}
                            styleInput={{
                                'width': '200px',
                                height: '32px',
                                lineHeight: '30px'
                            }}
                            getValue={this.getSearchValue}
                            onSearch={this.onSearch}
                            type={window.mode}
                            // iconName="icon-bsy-reportmenu-0"
                          />
                      </div>
                  </div> : <div className="check-menu">
                      <div className="close-btn" onClick={this.closeCheckMenu}>
                          <i className="icon-close-large"></i>
                      </div>
                      <div className="total-cont">
                            <span className="checked-num-wrapper">
                                <span className="checked-title">{React.language('msg.target.set.selected')}</span>
                                <span className="checked-num">{checkList.length}</span>
                                /{userCont.users.length}
                            </span>
                      </div>
                      {
                        BsyUtils.isCommon() && <div className="set-btn" onClick={this.memberDept}>
                            <i className="icon-signout"></i>
                            <span>{React.language("member.dept.alter")}</span>
                        </div>
                      }
                      {
                        (userCont.memberRemove && BsyUtils.isCommon()) && <div className="set-btn" onClick={this.dismissionClick}>
                            <i className="icon-resignation"></i>
                            <span>{React.language("switch.to.resignation")}</span>
                        </div>
                      }
                      {
                        <div className="set-btn" onClick={this.enableClick}>
                            <i className="icon-bsy-enable"></i>
                            <span>{React.language("enable")}</span>
                        </div>
                      }
                      {
                        <div className="set-btn" onClick={this.deactivateClick}>
                            <i className="icon-bsy-deactivate"></i>
                            <span>{React.language("deactivate")}</span>
                        </div>
                      }
                      {
                        (hasChild === false && deptId !== null && deptId !== undefined) && <div className="remove-btn" onClick={this.setJobTitle}>
                            <i className="icon-bsy-jobtitle-set"></i>
                            <span>{React.language("address.book.dept.set.title")}</span>
                        </div>
                      }

                  </div>}
                  {this.onBsyTurnPageMid()}
                  {/* {userCont.not_joined > 0 && <div className="joined-tip" onClick={e => {
                    this.againAllInvite()
                }} dangerouslySetInnerHTML={{__html: React.language('addressbook.joined.tip', {num: userCont.not_joined})}}/>} */}
                  {userCont.users &&
                    <BsyTableList
                      getValue={this.getTableValue}
                      limit={limit}
                      skip={skip}
                      skipChange={this.skipChange}
                      listLimitChange={this.listLimitChange}
                      listFilterChange={this.listFilterChange}
                      styleType={window.mode}
                      userCont={userCont}
                      count={userCont.count}
                      hasTurnPage={!!userCont.count}
                      list={list}
                      hasSetIcon={true}
                      listAll={listAll}
                      checkList={checkList}
                      checkListDetail={checkListDetail}
                      checked={checked}
                      onRowOrder={e => {
                          this.handleUserOrder(e)
                      }}
                      onRowClick={(e, node) => {
                          this.memberRowClick(e, node)
                      }}
                      onSortItem={(e) => {
                          this.onSortItem(e);
                      }}
                      onCheck={(e)=>{
                          this.onCheck(e)
                      }}
                    />}
              </div>}
          </div>
        );
    }
}

export default BsyUserCont;